var _rect, _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgYoutubeLogo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 144,
    height: 144,
    viewBox: "0 0 144 144",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 144,
    height: 144,
    rx: 72,
    fill: "#F2A6D6"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M109.6 91.3875C108.817 95.5 105.488 98.6333 101.375 99.2208C94.9125 100.2 84.1417 101.375 72 101.375C60.0542 101.375 49.2833 100.2 42.625 99.2208C38.5125 98.6333 35.1833 95.5 34.4 91.3875C33.6167 86.8833 32.8333 80.225 32.8333 72C32.8333 63.775 33.6167 57.1167 34.4 52.6125C35.1833 48.5 38.5125 45.3667 42.625 44.7792C49.0875 43.8 59.8583 42.625 72 42.625C84.1417 42.625 94.7167 43.8 101.375 44.7792C105.488 45.3667 108.817 48.5 109.6 52.6125C110.383 57.1167 111.363 63.775 111.363 72C111.167 80.225 110.383 86.8833 109.6 91.3875Z",
    fill: "#F5F0E7"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M64.1667 85.7083V58.2917L87.6667 72L64.1667 85.7083Z",
    fill: "#F2A6D6"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgYoutubeLogo);
export default __webpack_public_path__ + "static/media/youtube_logo.e87decb767f5eb2f6ad092b02ffc2215.svg";
export { ForwardRef as ReactComponent };